import request from "../../util/SuperagentUtils";
import { supplierReadyForPayoutReportEndpoints } from "../../requests/api-endpoints";

export const requestReadyForPayoutTransactionsForAccount = (query) => {
    return request.get(supplierReadyForPayoutReportEndpoints.search).query(query);
}

export const getReadyForPayoutReportUrl = (searchParams) => {
  const { locationId, sortBy, sortDir } = searchParams;
  const queryParams = new URLSearchParams();
  if (locationId) queryParams.append("locationId", locationId);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (sortDir) queryParams.append("sortDir", sortDir);

  return `${supplierReadyForPayoutReportEndpoints.report}?${queryParams}`;
}

export const getReadyForPayoutGroupSummaryReportUrl = (searchParams) => {
    const { locationId } = searchParams;
    const queryParams = new URLSearchParams();
    if (locationId) queryParams.append("locationId", locationId);

    return `${supplierReadyForPayoutReportEndpoints.group}?${queryParams}`;
}

export const requestInitiatePayouts = (body) => {
    return request.post(supplierReadyForPayoutReportEndpoints.actions.initiatePayouts).send(body);
}